import { css } from "styled-components";
/**
 * Use these helpers to visually hide elements but keep them accessible to
 * assistive technologies.
 *
 * Grabbed from Bootstrap: See
 * https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
 */
export const visuallyHidden = css `
  && {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }
`;
export default visuallyHidden;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlzdWFsbHlIaWRkZW4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbWl4aW5zL3Zpc3VhbGx5SGlkZGVuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUV4Qzs7Ozs7O0dBTUc7QUFDSCxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsR0FBRyxDQUFBOzs7Ozs7Ozs7Ozs7Q0FZaEMsQ0FBQztBQUVGLGVBQWUsY0FBYyxDQUFDIn0=